import { Checkbox, FormControlLabel } from '@mui/material'
import { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { useTypedDispatch, useTypedSelector } from '../..'
import { setHideServiceLimitations } from '../../reducers/defectsSlice'

const ServiceLimitationFilter = () => {
  const { t } = useTranslation()
  const dispatch = useTypedDispatch()
  const checked = useTypedSelector((state) => !state.defects.hideServiceLimitations)

  const onChange = (event: ChangeEvent<HTMLInputElement>) =>
    dispatch(setHideServiceLimitations(!event.target.checked))

  return (
    <FormControlLabel
      control={<Checkbox checked={checked} onChange={onChange} />}
      label={t('defect.filter.showServiceLimitations')}
    />
  )
}

export default ServiceLimitationFilter
